import * as React from 'react';
import { withStyles, Grid, WithStyles, Typography } from '@material-ui/core';
import { CSSProperties } from '@material-ui/core/styles/withStyles';

//#region UI configuration
const styles = () => ({
    container: {
        paddingTop: 136,
        paddingBottom: 16,
        '& img': {
            height: 28
        } as CSSProperties
    } as CSSProperties
});

type Styles = WithStyles<'container'>;
//#endregion

//#region Props & State
interface LoginLogoProps { }
interface LoginLogoState { }

type PropsWithStyles = LoginLogoProps & Styles;
//#endregion

class LoginLogo extends React.Component<PropsWithStyles, LoginLogoState> {

    render() {
        const { classes } = this.props;

        return (
            <Grid container={true} spacing={0} className={classes.container} justify="center">
                <Grid item={true}>
                    <Typography style={{ fontSize: 72 }}>🍇 VinVoir</Typography>
                </Grid>
            </Grid>
        );
    }
}

export default withStyles(styles)<LoginLogoProps>(LoginLogo);



// WEBPACK FOOTER //
// ./src/modules/login/LoginLogo.tsx